module.exports = __webpack_public_path__ + "img/fig1.09403799.svg";